/* eslint-disable no-restricted-globals */

import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "@douyinfe/semi-ui";
import { Nav } from "@douyinfe/semi-ui";
import { IconApps } from "@douyinfe/semi-icons";
import "./app.css";

import Apps from "./apps";

const { Header, Sider, Content } = Layout;

interface Component {
  name: string,
  path?: string,
  icon: JSX.Element,
  impl: JSX.Element,
}

const components: Component[] = [
  {
    name: "APP",
    icon: <IconApps />,
    impl: <Apps />
  }
];

const App = () =>
  <Layout style={{ width: "100%" }}>
    <Header>
      <Nav
        mode={"horizontal"}
        header={{
          logo: <img alt="logo" src={"/logo.png"} style={{ width: "86px" }} />,
          text: "金韦尔",
        }}
      />
    </Header>
    <Layout>
      <Sider>
        <Nav
          defaultSelectedKeys={[location.pathname.split("/")[1]]}
          items={
            components.map((comp) => {
              return {
                text: comp.name,
                itemKey: comp.path || "",
                icon: comp.icon,
                link: `/${comp.path || ""}`,
              }
            })
          }
          footer={{ collapseButton: true }}
        />
      </Sider>
      <Content style={{ margin: 25 }}>
        <Routes>
          {
            components.map((comp) => {
              return <Route
                index={!comp.path}
                path={comp.path}
                element={comp.impl} />;
            })
          }
        </Routes>
      </Content>
    </Layout>
  </Layout>;

export default App;
